module.exports = __webpack_public_path__ + "static/media/expand-icon.0ab06f03.svg";